export default __webpack_public_path__ + "static/media/search.03008155.svg";